/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  PmoMutation,
  createPmo,
  retrievePmos,
  savePmoFailure,
  savePmoSuccess,
} from '@store/scenario/pmo/pmo-slice';

export const createPmoEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType(createPmo.type),
  concatMap((action: PayloadAction<PmoMutation>) => {
    const uploadResult$ = action.payload.file
      ? from(dependencies.pmoGateway.uploadFile(action.payload.file))
      : of({ fileUrl: action.payload.pmo.fileUrl, originalFileName: action.payload.pmo.originalFileName });
    return uploadResult$.pipe(
      map(result => ({ ...action.payload.pmo, ...result })),
      concatMap(pmo => from(dependencies.pmoGateway.create(pmo))),
      concatMap(() => of(savePmoSuccess(), retrievePmos())),
      catchError(() => of(savePmoFailure('Failed to create PMO'))),
    );
  }),
);
